(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["okhomes-king-entertainment"] && !Shopify.designMode) return;
  try {
    function initKingEntertainment(root) {
  root.querySelectorAll('.okhomes-king').forEach(area => {
    if (area.dataset.kingReady) return;
    area.dataset.kingReady = 'true';
    const rail = area.querySelector('.okhomes-king__rail');
    const previous = area.querySelector('[data-king-direction="-1"]');
    const next = area.querySelector('[data-king-direction="1"]');
    const update = () => {
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    };
    area.querySelectorAll('[data-king-direction]').forEach(button => {
      button.addEventListener('click', () => {
        rail.scrollBy({left: Number(button.dataset.kingDirection) * (rail.querySelector('li').getBoundingClientRect().width + 14), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      });
    });
    rail.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    update();
  });
}
initKingEntertainment(document);
document.addEventListener('shopify:section:load', event => initKingEntertainment(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["okhomes-web-rating"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.okhomes-web-rating__panel').forEach(panel=>{
  if(location.hash==='#okhomes-web-rating')panel.open=true;
  window.addEventListener('hashchange',()=>{if(location.hash==='#okhomes-web-rating')panel.open=true;});
});
  } catch(e) { console.error(e); }
})();

})();
